var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Listing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1458"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1460"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1462 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0645 16.3064C10.0645 16.7073 10.3703 17.0322 10.7476 17.0322H11.7039C12.0812 17.0322 12.387 16.7073 12.387 16.3064C12.387 15.9056 12.0812 15.5806 11.7039 15.5806H10.7476C10.3703 15.5806 10.0645 15.9056 10.0645 16.3064Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g1464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1466 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0645 11.8549C10.0645 12.2557 10.3792 12.5807 10.7674 12.5807H16.8131C17.2013 12.5807 17.5161 12.2557 17.5161 11.8549C17.5161 11.454 17.2013 11.1291 16.8131 11.1291H10.7674C10.3792 11.1291 10.0645 11.454 10.0645 11.8549Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g1468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1470 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0645 7.64521C10.0645 8.01934 10.3792 8.32263 10.7674 8.32263H16.8131C17.2013 8.32263 17.5161 8.01934 17.5161 7.64521C17.5161 7.27108 17.2013 6.96779 16.8131 6.96779H10.7674C10.3792 6.96779 10.0645 7.27108 10.0645 7.64521Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g1472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1474 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48438 16.3064C6.48438 16.7073 6.80211 17.0322 7.19405 17.0322H7.90373C8.29567 17.0322 8.61341 16.7073 8.61341 16.3064C8.61341 15.9056 8.29567 15.5806 7.90373 15.5806H7.19405C6.80211 15.5806 6.48438 15.9056 6.48438 16.3064Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "g1476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1478 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48438 11.8549C6.48438 12.2557 6.80211 12.5807 7.19405 12.5807H7.90373C8.29567 12.5807 8.61341 12.2557 8.61341 11.8549C8.61341 11.454 8.29567 11.1291 7.90373 11.1291H7.19405C6.80211 11.1291 6.48438 11.454 6.48438 11.8549Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g1480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1482 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48438 7.64521C6.48438 8.01934 6.80211 8.32263 7.19405 8.32263H7.90373C8.29567 8.32263 8.61341 8.01934 8.61341 7.64521C8.61341 7.27108 8.29567 6.96779 7.90373 6.96779H7.19405C6.80211 6.96779 6.48438 7.27108 6.48438 7.64521Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_325_1048",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clipPath1490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1488",
    d: "M3 3H21V21H3V3Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_325_1048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1494 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9831 18.6129C16.018 18.6129 15.2357 17.8185 15.2357 16.8387C15.2357 15.8588 16.018 15.0645 16.9831 15.0645C17.9481 15.0645 18.7304 15.8588 18.7304 16.8387C18.7304 17.8185 17.9481 18.6129 16.9831 18.6129ZM13.8379 16.8387C13.8379 18.6024 15.246 20.0322 16.9831 20.0322C18.7201 20.0322 20.1282 18.6024 20.1282 16.8387C20.1282 15.0749 18.7201 13.6451 16.9831 13.6451C15.246 13.6451 13.8379 15.0749 13.8379 16.8387Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1498 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.796 20.7951C21.0692 20.5219 21.0692 20.079 20.796 19.8058L19.2919 18.3017C19.0187 18.0285 18.5758 18.0285 18.3026 18.3017C18.0294 18.5749 18.0294 19.0178 18.3026 19.291L19.8066 20.7951C20.0798 21.0683 20.5228 21.0683 20.796 20.7951Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1500"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1502 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18.1875C3 19.7408 4.2592 21 5.8125 21H13.0547C13.443 21 13.7578 20.6852 13.7578 20.2969C13.7578 19.9085 13.443 19.5938 13.0547 19.5938H5.8125C5.03585 19.5938 4.40625 18.9641 4.40625 18.1875V5.8125C4.40625 5.03585 5.03585 4.40625 5.8125 4.40625H18.1875C18.9641 4.40625 19.5938 5.03585 19.5938 5.8125V12.7734C19.5938 13.1618 19.9086 13.4766 20.2969 13.4766C20.6852 13.4766 21 13.1618 21 12.7734V5.8125C21 4.2592 19.7408 3 18.1875 3H5.8125C4.2592 3 3 4.2592 3 5.8125V18.1875Z",
    fill: "white"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListing);
export default __webpack_public_path__ + "static/media/Listing.630260bbf65f1fa02db302aa144da7ca.svg";
export { ForwardRef as ReactComponent };